module.exports = __webpack_public_path__ + "static/media/linkIcon.c5d2bc4f.svg";